const NextIcon = () => {
  return (
    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.821851 15.1156C0.653101 15.1156 0.512476 15.0594 0.371851 14.9469C0.118726 14.6938 0.118726 14.3 0.371851 14.0469L6.2781 8L0.371851 1.98125C0.118726 1.72813 0.118726 1.33438 0.371851 1.08125C0.624976 0.828126 1.01873 0.828126 1.27185 1.08125L7.6281 7.55C7.88123 7.80313 7.88123 8.19688 7.6281 8.45L1.27185 14.9188C1.15935 15.0313 0.990601 15.1156 0.821851 15.1156Z"
        fill="#637381"
      />
    </svg>
  );
};

export default NextIcon;
